import { render, staticRenderFns } from "./ordersDeliveryPrintDetailTable.vue?vue&type=template&id=131f86e3&"
import script from "./ordersDeliveryPrintDetailTable.vue?vue&type=script&lang=ts&"
export * from "./ordersDeliveryPrintDetailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports